<template>
  <footer id="footer">
    <div class="info-footer-derek">
      <div class="container-max-width d-flex flex-wrap justify-content-center">
        <div class="col-12 col-md-3 item-info-footer-derek">
          <div class="container-img">
            <img class="mb-2" src="@/assets/img/compra-segura.svg" alt="" />
          </div>
          <p class="title-item-footer-derek">Compra segura y protegida</p>
          <p class="description-item-footer-derek">
            Encriptamos todos tus datos y contamos con todas las certificaciones
            de seguridad.
          </p>
        </div>
        <div class="col-12 col-md-3 item-info-footer-derek">
          <div class="container-img">
            <img class="mb-2" src="@/assets/img/envios.svg" alt="" />
          </div>
          <p class="title-item-footer-derek">Envíos nacionales</p>
          <p class="description-item-footer-derek">
            ¿Sabías qué nuestros productos llegan a más de 800 municipios de
            Colombia?
          </p>
        </div>
        <div class="col-12 col-md-3 item-info-footer-derek">
          <div class="container-img">
            <img class="mb-2" src="@/assets/img/devoluciones.svg" alt="" />
          </div>
          <p class="title-item-footer-derek">Devoluciones sin costo</p>
          <p class="description-item-footer-derek">
            ¿No es tu talla? No te preocupes puedes devolver los productos de
            forma rápida y gratuita.
          </p>
        </div>
      </div>
    </div>
    <news-latter />
    <div class="footer-top container-max-width">
      <div id="footer-1" class="d-block d-md-flex">
        <div class="col-12 d-block d-md-flex">
          <div class="col-12 col-md-4 d-flex align-items-start">
            <div class="d-flex flex-wrap d-md-grid justify-content-between">
              <div class="ps-md-5 col col-md-12 mb-4">
                <svg
                  id="XMLID_13_"
                  style="cursor: pointer;"
                  class="mb-auto mb-md-5 me-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="31.1"
                  viewBox="0 0 100 31.1"
                  @click="$router.push({ name: 'Home' })"
                >
                  <path
                    id="XMLID_4_"
                    d="M27.461,18.121l14.485.112v-.28a5.876,5.876,0,0,0-1.9-4.7,7.779,7.779,0,0,0-5.313-1.734,7.222,7.222,0,0,0-5.145,1.79,6.776,6.776,0,0,0-2.125,4.81ZM77.908,30.7l.056-4.978A7.155,7.155,0,0,1,75,29.418Q72.232,31.18,67.282,31.1a11.756,11.756,0,0,1-8.389-2.908,10.537,10.537,0,0,1-3.02-7.942A11.029,11.029,0,0,1,58.5,12.64h-.28q-4.362,0-6.376,1.846c-1.342,1.286-2.069,3.3-2.069,6.04l-.056,9.955H45.582l.056-9.676-18.345-.112a7.482,7.482,0,0,0,2.013,5.481A7.734,7.734,0,0,0,34.9,28.132a7.881,7.881,0,0,0,4.362-1.063,4.353,4.353,0,0,0,2.013-3.076l4.362.056a7.324,7.324,0,0,1-3.356,5.257q-2.768,1.762-7.718,1.678a11.756,11.756,0,0,1-8.389-2.908A8.939,8.939,0,0,1,24.049,25c0,1.063,0,2.013.056,2.8.056.951.168,1.846.28,2.685H20.246l-.28-3.244a10,10,0,0,1-3.747,2.8,12.551,12.551,0,0,1-4.978.895A11.23,11.23,0,0,1,3.02,27.852,11.513,11.513,0,0,1,0,19.575a10.365,10.365,0,0,1,3.188-8c2.069-2.013,4.866-2.964,8.333-2.964a11.54,11.54,0,0,1,4.7.895,12.5,12.5,0,0,1,3.915,2.573L20.19,0h4.027l-.112,15.1a10.11,10.11,0,0,1,2.349-3.356,12.406,12.406,0,0,1,8.781-3.02c3.523,0,6.208,1.007,8.054,2.852a9.4,9.4,0,0,1,2.4,4.474c0-1.007,0-2.013-.056-3.076-.056-1.23-.112-2.461-.28-3.691H49.5l.168,3.971A7.542,7.542,0,0,1,52.908,9.9a11.712,11.712,0,0,1,5.425-1.063h.783v3.076l.056-.056a12.406,12.406,0,0,1,8.781-3.02c3.523,0,6.208,1.007,8.054,2.852a9.707,9.707,0,0,1,2.013,3.132L78.132.168h4.027L82.047,17.9,93.009,9.452l5.369.056-11.745,9L100,30.7l-5.872-.056L82.047,19.016l-.112,11.745Zm.056-6.488V21.029l-17.953-.112A7.263,7.263,0,0,0,62.025,26.4a7.734,7.734,0,0,0,5.593,1.957,7.881,7.881,0,0,0,4.362-1.063,4.353,4.353,0,0,0,2.013-3.076ZM60.179,18.345l14.485.112v-.28a5.876,5.876,0,0,0-1.9-4.7,8.069,8.069,0,0,0-5.313-1.734,7.314,7.314,0,0,0-5.145,1.79,6.776,6.776,0,0,0-2.125,4.81ZM4.195,19.687a8.2,8.2,0,0,0,2.069,5.984,7.717,7.717,0,0,0,5.817,2.181,8.158,8.158,0,0,0,5.928-2.181A7.749,7.749,0,0,0,20.3,19.855,8.323,8.323,0,0,0,18.177,13.7a7.846,7.846,0,0,0-5.984-2.237A7.936,7.936,0,0,0,6.32,13.647a8.367,8.367,0,0,0-2.125,6.04Z"
                    fill="#fafafa"
                  />
                </svg>
                <div class="w-100 mt-4 d-flex d-md-none">
                  <a target="_blank" href="https://www.sic.gov.co/">
                    <img
                      src="@/assets/icons/industriaycomercio.svg"
                      aria-label="Icon industria y comercio"
                      class="my-auto mb-4 ms-md-5"
                    />
                  </a>
                </div>
              </div>
              <div class="ps-md-5 mb-5">
                <a
                  href="https://www.facebook.com/derekaddict"
                  target="_blank"
                  class="text-center text-md-start"
                  ><img
                    class="pb-2 pe-2"
                    src="@/assets/icons/facebook.svg"
                    alt=""
                  />
                  Facebook /
                </a>
                <br />
                <a
                  href="https://www.instagram.com/derekaddict/"
                  target="_blank"
                  class="text-center text-md-start"
                  ><img
                    class="pb-2 pe-2"
                    src="@/assets/icons/instagram.svg"
                    alt=""
                  />
                  Instagram /
                </a>
                <br />
                <a
                  href="https://twitter.com/DerekAddict"
                  target="_blank"
                  class="text-center text-md-start"
                  ><img
                    class="pb-2 pe-2"
                    src="@/assets/icons/twitter.svg"
                    alt=""
                  />
                  Twitter /
                </a>
              </div>
              <div class="w-100 d-none d-md-flex">
                <a target="_blank" href="https://www.sic.gov.co/">
                  <img
                    src="@/assets/icons/industriaycomercio.svg"
                    aria-label="Icon industria y comercio"
                    class="my-auto mb-4 ms-md-5"
                  />
                </a>
              </div>
              <div
                class="content-medios-pago mt-auto p-2 mb-0 d-none d-md-flex"
              >
                <img
                  src="@/assets/icons/mediosPago/visa.svg"
                  alt="icono visa"
                  style="max-width: 40px"
                />
                <img
                  src="@/assets/icons/mediosPago/mastercard.svg"
                  alt="icono mastercard"
                  style="max-width: 32px"
                />
                <img
                  src="@/assets/icons/mediosPago/diners.svg"
                  alt="icono diners"
                  style="max-width: 66px"
                />
                <img
                  src="@/assets/icons/mediosPago/pse.svg"
                  alt="icono pse"
                  style="max-width: 33px"
                />
                <img
                  src="@/assets/icons/mediosPago/amex.svg"
                  alt="icono american express"
                  style="max-width: 32px"
                />
                <img
                  src="@/assets/icons/mediosPago/efecty.svg"
                  alt="icono efecty"
                  style="max-width: 58px"
                />
                <img
                  src="@/assets/icons/mediosPago/nequi.svg"
                  alt="icono nequi"
                  style="max-width: 72px"
                />
                <img
                  src="@/assets/icons/mediosPago/daviplata.svg"
                  alt="icono daviplata"
                  style="max-width: 38px"
                />
                <img
                  src="@/assets/icons/mediosPago/rappi.svg"
                  alt="icono rappi"
                  style="max-width: 39px"
                />
                <img
                  src="@/assets/icons/mediosPago/addi.svg"
                  alt="icono addi"
                  style="max-width: 47px"
                />
                <img
                  src="@/assets/icons/mediosPago/quac.svg"
                  alt="icono quac"
                  style="max-width: 60px"
                />
                <img
                  src="@/assets/icons/mediosPago/sistecredito.svg"
                  alt="icono sistecredito"
                  style="max-width: 82px; width: 100%;"
                />
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap col-12 col-md-8">
            <div class="col-12 col-md-4">
              <p class="titulo-section-footer ps-lg-4">
                ATENCIÓN AL CLIENTE
              </p>
              <div class="d-grid ps-lg-4">
                <p class="mb-3">
                  <b>WhatsApp</b>
                  <br />
                  <a
                    target="_blank"
                    href="https://api.whatsapp.com/send?phone=573232747474&text=Hola!%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"
                  >
                    323 274 7474
                  </a>
                </p>
                <p class="mb-3">
                  <b>Línea nacional</b>
                  <br />
                  <a href="tel:018000423550"> 01 8000 423550 </a>
                </p>
                <p class="mb-3">
                  <b>Correo electrónico</b>
                  <br />
                  <a href="mailto:servicioalcliente@derek.co">
                    servicioalcliente@derek.co
                  </a>
                </p>
                <p class="mb-3">
                  <b>Horario de atención</b>
                  <br />
                  Lunes a viernes 8:00 am a 7:00 pm
                  <br />
                  Sábados 8:30 am a 5:30 pm
                </p>
                <p class="mb-3">
                  <b>Radicación PQRS</b>
                  <br />
                  <a
                    class="mb-3"
                    target="_blank"
                    href="https://grupobaguer.com/pqrs.php?BAGUER"
                  >
                    Radica tu PQR aquí
                  </a>
                </p>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <p class="titulo-section-footer ps-lg-4">
                INFORMACIÓN
              </p>
              <div class="d-grid ps-lg-4">
                <div
                  v-for="(politica, index) in pagesStaticas"
                  :key="index"
                  :class="politica.tipo_pagina == 0 ? 'mb-3' : ''"
                >
                  <router-link
                    v-if="politica.tipo_pagina == 0"
                    :to="{ name: 'Politicas', params: { slug: politica.slug } }"
                    >{{ politica.titulo }}</router-link
                  >
                </div>
                <router-link class="mb-3" :to="{ name: 'Preguntasfrecuentes' }"
                  >Preguntas frecuentes</router-link
                >
                <router-link class="mb-3" :to="{ name: 'Tiendas' }"
                  >Encuentra una tienda</router-link
                >
                <router-link class="mb-3" :to="{ name: 'FollowOrder' }"
                  >Sigue tu pedido</router-link
                >
                <a class="mb-3" href="https://portalpagos.derek.co">
                  Paga tu cuota
                </a>
                <router-link class="mb-3" :to="{ name: 'Returns' }"
                  >Devoluciones</router-link
                >
                <router-link class="mb-3" :to="{ name: 'Sizeguide' }"
                  >Guía de tallas</router-link
                >
                <!-- <router-link class="mb-3" :to="{ name: 'Franquicia' }"
                  >Franquicias</router-link
                > -->
              </div>
            </div>
            <div class="col-12 col-md-4">
              <p class="titulo-section-footer ps-lg-4">
                POLÍTICAS
              </p>
              <div class="d-grid ps-lg-4">
                <div
                  v-for="(politica, index) in dataPoliticas"
                  :key="index"
                  class="mb-1"
                >
                  <router-link
                    v-if="politica.tipo_pagina == 0"
                    :to="{ name: 'Politicas', params: { slug: politica.slug } }"
                    >• {{ politica.titulo }}</router-link
                  >
                </div>
                <div class="mb-1">
                  <a
                    href="https://centroderelevo.gov.co/632/w3-channel.html"
                    target="_blank"
                  >
                    • Servicio para personas ciegas y sordociegas
                  </a>
                </div>
              </div>
            </div>
            <div
              class="content-medios-pago mt-auto p-2 mb-0 d-flex d-md-none mb-2"
              style="background-color: #FAFAFA; margin: auto -2rem"
            >
              <img
                src="@/assets/icons/mediosPago/visa.svg"
                alt="icono visa"
                style="max-width: 40px"
              />
              <img
                src="@/assets/icons/mediosPago/mastercard.svg"
                alt="icono mastercard"
                style="max-width: 32px"
              />
              <img
                src="@/assets/icons/mediosPago/diners.svg"
                alt="icono diners"
                style="max-width: 66px"
              />
              <img
                src="@/assets/icons/mediosPago/pse.svg"
                alt="icono pse"
                style="max-width: 33px"
              />
              <img
                src="@/assets/icons/mediosPago/amex.svg"
                alt="icono american express"
                style="max-width: 32px"
              />
              <img
                src="@/assets/icons/mediosPago/efecty.svg"
                alt="icono efecty"
                style="max-width: 58px"
              />
              <img
                src="@/assets/icons/mediosPago/nequi.svg"
                alt="icono nequi"
                style="max-width: 72px"
              />
              <img
                src="@/assets/icons/mediosPago/daviplata.svg"
                alt="icono daviplata"
                style="max-width: 38px"
              />
              <img
                src="@/assets/icons/mediosPago/rappi.svg"
                alt="icono rappi"
                style="max-width: 39px"
              />
              <img
                src="@/assets/icons/mediosPago/addi.svg"
                alt="icono addi"
                style="max-width: 47px"
              />
              <img
                src="@/assets/icons/mediosPago/quac.svg"
                alt="icono quac"
                style="max-width: 60px"
              />
              <img
                src="@/assets/icons/mediosPago/sistecredito.svg"
                alt="icono sistecredito"
                style="max-width: 82px"
              />
            </div>
            <div class="col-12 px-4 px-md-5 py-2">
              <p class="date-footer w-100">
                © Todos los derechos reservados a Baguer S.A.S.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button-help />
  </footer>
</template>
<script>
import ButtonHelp from '@/components/Footer/ButtonHelp'
import NewsLatter from '@/components/Footer/NewsLatter'

import { mapState, mapActions } from 'vuex'
import { GA4SignUp } from '@/GA4/events'
import { sendFBQEvent } from '@/fbq'
export default {
  components: { ButtonHelp, NewsLatter },
  data() {
    return {
      tipoFooter: 1,
      validateStep1: false,
      validateStep2: false,
      validateStep3: false,
      showDiscound: false,
      correo: '',
      stepNewslatter: 0,
      day: null,
      month: null,
      tel: '',
      cel_newslatter: false,
      stateNewslatter: {
        title: 'Únete a la comunidad derek',
        text:
          'Entérate de las últimas noticias del mundo derek, lanzamientos de colecciones, eventos exclusivos, descuentos y mucho más.',
      },
      tyc: true,
      dataPoliticas: [],
      pagesStaticas: [],
    }
  },
  computed: {
    /* eslint-disable */
    ...mapState('user', ['errorNewsLatter', 'msgerrorNewsLatter']),
    validateEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.correo)
    },
    validatePhone() {
      if (!this.cel_newslatter) {
        return true
      } else {
        const re = /^3[0-9]{9}/
        return re.test(this.tel) && this.tel.length < 11
      }
    },
  },
  async mounted() {
    await this.axios({
      method: 'GET',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      url: 'layouts/get_footer',
    })
      .then(response => {
        this.pagesStaticas = response.data.bloque1
        this.dataPoliticas = response.data.bloque2
      })
      .catch(error => {
        console.log(error)
      })
  },
  watch: {
    day() {
      if (this.month) {
        this.validateStep1 = false
      }
    },
    month() {
      if (this.day) {
        this.validateStep1 = false
      }
    },
    cel_newslatter() {
      if (this.cel_newslatter) {
      } else {
        if (this.tyc) {
          this.validateStep3 = false
        }
      }
    },
  },
  methods: {
    ...mapActions('user', ['suscribeDerek']),
    validateSendDataNewsLatter() {
      if (this.tyc) {
        if (
          !this.cel_newslatter ||
          (this.cel_newslatter && this.validatePhone)
        ) {
          this.validateStep3 = false
          this.validateDataNewsLatter()
        } else {
          this.validateStep3 = true
        }
      } else {
        this.validateStep3 = true
      }
    },
    async validateDataNewsLatter() {
      if (this.validateEmail) {
        await this.suscribeDerek({
          correo: this.correo,
          day: this.day,
          month: this.month,
          sms: this.cel_newslatter ? 1 : 0,
          tel: this.tel ? this.tel : '',
          step: 2,
        }).then(() => {
          if (!this.errorNewsLatter) {
            this.stateNewslatter = {
              title: '¡Bienvenida!',
              text: 'Haces parte de la comunidad más exclusiva de la moda.',
            }
            document.cookie = 'email=' + this.correo
            this.$bvModal.show('modal-done-newsletter')
            sendFBQEvent(this, 'Subscribe', {})
            GA4SignUp('NewsLatter')
            this.correo = ''
            this.stepNewslatter += 1
          }
        })
      } else {
        this.$store.state.user.errorNewsLatter = true
      }
    },
    async validateService() {
      if (this.validateEmail) {
        await this.suscribeDerek({
          correo: this.correo,
          day: this.day,
          month: this.month,
          sms: this.cel_newslatter ? 1 : 0,
          tel: this.tel ? this.tel : '',
          step: 1,
        }).then(() => {
          if (!this.msgerrorNewsLatter) {
            this.stepNewslatter += 1
          }
        })
      } else {
        this.validateStep2 = true
      }
    },
  },
}
</script>
